export interface HttpErrorDetails {
  status?: number;
  responseJSON?: unknown;
  toString(): string;
}

export function hasHttpErrorDetails(error: unknown): error is HttpErrorDetails {
  return typeof error === 'object' && error !== null;
}
